import { ICreateTableSales, IFieldArray } from '@interfaces/tables/tableSales'
import React from 'react'
import { FieldArrayWithId, useFormContext } from 'react-hook-form'
import TableSalesRow from './TableSalesRow'

interface IProps {
    columns: IFieldArray[]
    rows: FieldArrayWithId<ICreateTableSales, 'rows', 'id'>[]
    remove: (index: number) => void
}

export default function TableSaleBody(props: IProps): React.ReactElement {
    const { register } = useFormContext()

    return (
        <React.Fragment>
            {props.rows.map((row, ir) => (
                <TableSalesRow row={row} columns={props.columns} index={ir} key={ir} remove={props.remove} register={register} />
            ))}
        </React.Fragment>
    )
}
